import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';

import { EVENT } from '../../../shared/constants/dali.constants';
import { OpEnum } from '../../../shared/enums/op.enum';
import { CountryModel, ForeignProductsModel, OfficeModel } from '../../../shared/models/abre-cuentas.model';
import { Changes, TagEvent } from '../../../shared/models/dali-tags.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CaptureService } from '../../../shared/services/capture/capture.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { TaggingService } from '../../../shared/services/tagging/tagging.service';

@Component({
  selector: 'app-foreign-products-detail',
  templateUrl: './foreign-products-detail.component.html',
  styleUrls: ['./foreign-products-detail.component.scss'],
})
export class ForeignProductsDetailComponent implements OnInit {

  formGroup: FormGroup;
  options: any;
  selectedCountry: CountryModel;
  productInfo: ForeignProductsModel;
  officeInfo: OfficeModel;
  customError: string;

  configAmountField = { allowNegative: false, decimal: ',', precision: 0, thousands: '.', prefix: '$ ' };

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private captureService: CaptureService,
    private taggingService: TaggingService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService) {
    this.headerService.show(true, true, true);
  }

  /**
   * Summary Charge data for contact and set in false Selected Option
   */
  ngOnInit() {
    this.options = this.parametersService.getSetting(OpEnum.COUNTRY_LIST);
    this.productInfo = this.abreCuentasService.getProductInfo();

    const numberValidator = [Validators.required, Validators.maxLength(20), Validators.pattern('^[0-9]*$')];
    const justLettersValidator = [Validators.required, Validators.maxLength(20), Validators.pattern('^[a-zA-ZñÑáéíóúÁÉÍÓÚ]*$')];
    const alphaNumericValidator = [Validators.required, Validators.maxLength(20), Validators.pattern('^[\sa-zA-ZñÑáéíóúÁÉÍÓÚ0-9 ]*$')];
    this.formGroup = new FormGroup({
      'input-value-product-type': new FormControl(this.productInfo.product_type, alphaNumericValidator),
      'input-value-product-id': new FormControl(this.productInfo.product_id, numberValidator),
      'input-value-entity': new FormControl(this.productInfo.entity_name, [Validators.required]),
      'input-value-amount': new FormControl(this.productInfo.amount, [Validators.required]),
      'input-value-currency': new FormControl(this.productInfo.currency, justLettersValidator),
    });

    if (this.abreCuentasService.getProductInfo().product_type !== undefined) {
      this.selectedCountry = this.productInfo.country;
      return;
    }
    this.productInfo = {
      product_type: '',
      product_id: '',
      entity_name: '',
      currency: '',
      amount: '',
      country: { country_code: '', description: '' },
    };
    this.selectedCountry = { country_code: '', description: '' };
  }

  /**
   * Summary ProductType entry change event, error validation
   */
  reactiveInputChangeProductType() {
    const controlProductType = this.formGroup.controls['input-value-product-type'] as FormControl;
    controlProductType.setValue(controlProductType.value.replace(/[^a-zA-ZñÑáéíóúÁÉÍÓÚ0-9\s#\-.]/g, '').replace(/\s{2,}/g, ' '));
  }

  /**
   * Summary Entity entry change event, error validation
   */
  reactiveInputChangeEntity() {
    const controlEntity = this.formGroup.controls['input-value-entity'] as FormControl;
    controlEntity.setValue(controlEntity.value.replace(/[^a-zA-ZñÑáéíóúÁÉÍÓÚ0-9\s#\-.]/g, '').replace(/\s{2,}/g, ' '));
  }

  /**
   * Summary Country entry change event
   */
  reactiveInputChangeCountry(option: any) {
    this.selectedCountry = option.value;
  }

  /**
   * event mail entry change, error validation
   */
  next() {
    this.tagNextButton();
    if (this.selectedCountry.country_code !== 'USA') {
      const amount: string = this.formGroup.controls['input-value-amount'].value.split(/\./)[0];
      this.productInfo = {
        product_type: this.formGroup.controls['input-value-product-type'].value,
        product_id: this.formGroup.controls['input-value-product-id'].value,
        entity_name: this.formGroup.controls['input-value-entity'].value,
        amount,
        currency: this.formGroup.controls['input-value-currency'].value,
        country: this.selectedCountry,
      };
      this.abreCuentasService.setProductInfo(this.productInfo);
      this.captureService.sendProspectForeignCurrencyProducts(this.productInfo).then(
        (response: any) => {
          if (!response) {
            return;
          }
          this.navigationService.nextStep('200');
        },
      ).catch(() => this.navigationService.navigateToGeneralInformation('500'));
    } else {
      this.navigationService.pageLoadTag('ErrorProductosExtranjero', ['pv52', 'pv188', 'pv166']);
      this.navigationService.navigateToGeneralInformation('301');
    }
  }

  tagNextButton() {
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    try {
      const changes: Changes[] = [
        {
          path: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionName`].path,
          value: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionName`].value,
        },
        {
          path: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionDetailsProductcategory`].path,
          value: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionDetailsProductcategory`].value,
        },
        {
          path: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionDetailsTransactioninstitution`].path,
          value: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionDetailsTransactioninstitution`].value,
        },
      ];

      const event: TagEvent = {
        events: [
          {
            name: EVENT[`${tagPageName}E1events`].name,
            value: EVENT[`${tagPageName}E1events`].value,
          },
        ],
        category: {
          module: EVENT.customCategory.module.body,
          type: EVENT.customCategory.type.button,
          position: EVENT.customCategory.position.bottom,
        },
        action: EVENT.customAction.click,
        label: EVENT[`${tagPageName}E1customLabel`] + `TipoProducto | ${this.productInfo.product_type}`,
      };
      this.taggingService.pageTagEvent(event, changes);
    } catch (err) {
      console.log(err);
    }
  }

  keyPressInput(event) {
    if (event.keyCode < 48 || event.keyCode > 57) {
      return false;
    }
    return true;
  }

}
